const adminMeta = {
  resource: 'OfferWall Providers',
  action: 'manage',
  navActiveLink: 'dashboard-google-ads',
}

const adminOnly = (to, from, next) => {
  const userData = JSON.parse(localStorage.getItem('userData') || '{}')
  const roles = [
    ...(Array.isArray(userData.roles) ? userData.roles : []),
    ...(Array.isArray(userData.role) ? userData.role : []),
    ...(typeof userData.role === 'string' ? [userData.role] : []),
  ].map(role => String(role).toLowerCase())

  if (roles.includes('admin')) {
    next()
    return
  }

  next({ name: 'misc-not-authorized' })
}

export default [
  {
    path: '/offerwall/providers',
    name: 'dashboard-offerwall-providers',
    component: () => import('@/views/dashboard/offerwall-providers/List.vue'),
    meta: adminMeta,
    beforeEnter: adminOnly,
  },
  {
    path: '/offerwall/providers/create',
    name: 'dashboard-offerwall-provider-create',
    component: () => import('@/views/dashboard/offerwall-providers/Form.vue'),
    meta: adminMeta,
    beforeEnter: adminOnly,
  },
  {
    path: '/offerwall/providers/:id/edit',
    name: 'dashboard-offerwall-provider-edit',
    component: () => import('@/views/dashboard/offerwall-providers/Form.vue'),
    meta: adminMeta,
    beforeEnter: adminOnly,
  },
]
